




import {Vue, Component, Mixins, Prop} from 'vue-property-decorator';
import UserRoleMixin from '@/mixins/UserRoleMixin.vue';
import CurrencyMixin from '@/mixins/CurrencyMixin.vue';
@Component({
    components: {
    },
})
export default class PaymentBadge extends Mixins(UserRoleMixin, CurrencyMixin) {
    @Prop({default: 0})
    public amount!: number;
}
